import React from "react";
import Layout from "../layout/Layout";
import Banner from "../components/hospitality/Banner";
import IndustryLeaders from "../components/industry-leaders/industry-leaders";
import Intro from "../components/hospitality/Intro";
import FeaturesList from "../components/hospitality/FeaturesList";
import Benefits from "../components/hospitality/Benefits";
import Cta from "../components/hospitality/Cta";
import Testimonials from "../components/hospitality/Testimonials";

const Hospitality = () => {
  return (
    <Layout>
      <Banner />
      <IndustryLeaders />
      <Intro />
      <FeaturesList />
      <Benefits />
      <Cta />
      <Testimonials />
    </Layout>
  );
};

export default Hospitality;
